import { Button } from "../../primitives/Button";
import type { Promotion } from "../../../api/catalog";

type PromotionTabDetailsProps = {
  promotion: Promotion;
  onEdit: () => void;
  onActivate: () => void;
  onPause: () => void;
  onArchive: () => void;
  isLocked: boolean;
};

export function PromotionTabDetails({
  promotion,
  onEdit,
  onActivate,
  onPause,
  onArchive,
  isLocked,
}: PromotionTabDetailsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-text">Détails</h3>
        {!isLocked && (
          <Button label="Modifier" intent="primary" size="sm" onClick={onEdit} />
        )}
      </div>

      <div className="rounded-md border border-border bg-surface p-4 space-y-4">
        <div>
          <label className="text-xs text-muted">Nom</label>
          <div className="mt-1 text-sm text-text">{promotion.name}</div>
        </div>
        {promotion.description && (
          <div>
            <label className="text-xs text-muted">Description</label>
            <div className="mt-1 text-sm text-text">{promotion.description}</div>
          </div>
        )}
        <div>
          <label className="text-xs text-muted">Mode d'application</label>
          <div className="mt-1 text-sm text-text">
            {promotion.code ? "Code promo" : "Automatique"}
          </div>
          {promotion.code && (
            <div className="mt-1 text-sm font-medium text-primary">{promotion.code}</div>
          )}
        </div>
        <div>
          <label className="text-xs text-muted">Statut</label>
          <div className="mt-1">
            <span
              className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${
                promotion.status === "active"
                  ? "bg-success/10 text-success"
                  : promotion.status === "paused"
                  ? "bg-warning/10 text-warning"
                  : promotion.status === "archived"
                  ? "bg-muted/10 text-muted"
                  : "bg-surface-muted text-muted"
              }`}
            >
              {promotion.status === "draft"
                ? "Brouillon"
                : promotion.status === "active"
                ? "Active"
                : promotion.status === "paused"
                ? "En pause"
                : "Archivée"}
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        {promotion.status === "draft" && (
          <Button label="Activer" intent="primary" size="sm" onClick={onActivate} />
        )}
        {promotion.status === "active" && (
          <Button label="Mettre en pause" intent="default" size="sm" onClick={onPause} />
        )}
        {promotion.status === "paused" && (
          <Button label="Activer" intent="primary" size="sm" onClick={onActivate} />
        )}
        {promotion.status !== "archived" && (
          <Button label="Archiver" intent="danger" size="sm" onClick={onArchive} />
        )}
      </div>
    </div>
  );
}
